import React, { useMemo } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useTheme } from '../../contexts/ThemeContext';
import useTradingRulesMetrics from '../../hooks/useTradingRulesMetrics';
import ViolationsTable from './ViolationsTable';

function filterLast7Days(violations) {
  const now = Date.now();
  const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
  const cutoff = now - sevenDaysMs;

  return (violations || []).filter((v) => {
    const ts = v?.violation_timestamp || v?.timestamp || v?.created_at;
    if (!ts) return true;
    const t = new Date(ts).getTime();
    if (Number.isNaN(t)) return true;
    return t >= cutoff;
  });
}

export default function RuleViolationsModal({ show, onHide, accountId }) {
  const { colors } = useTheme();

  const account = useMemo(() => {
    if (!accountId) return null;
    return { AccountID: accountId };
  }, [accountId]);

  const { violations, loading, error } = useTradingRulesMetrics(account, show ? '7days' : null);
  const last7DaysViolations = useMemo(() => filterLast7Days(violations), [violations]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header
        closeButton
        style={{
          backgroundColor: colors.bgCard,
          borderColor: colors.border,
          color: colors.text,
        }}
      >
        <Modal.Title style={{ fontSize: '1rem', display: 'flex', alignItems: 'baseline', gap: 8 }}>
          <span>Rule Violations</span>
          <em style={{ fontSize: '0.9rem', color: colors.textMuted, fontWeight: 400 }}>
            last 7 days
          </em>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: colors.bgCard, color: colors.text }}>
        {!accountId ? (
          <div style={{ color: colors.textMuted, fontSize: '0.9rem' }}>
            Select an account to view violations.
          </div>
        ) : loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
            <Spinner animation="border" variant="primary" />
          </div>
        ) : error ? (
          <div style={{ color: colors.danger || '#dc3545', fontSize: '0.9rem' }}>
            {String(error)}
          </div>
        ) : last7DaysViolations.length === 0 ? (
          <div style={{ color: colors.textMuted, fontSize: '0.9rem' }}>
            No rule violations in the last 7 days.
          </div>
        ) : (
          <ViolationsTable
            violations={last7DaysViolations}
            accountId={accountId}
            noCardWrapper={true}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

